// @flow
import { CategoriasPOIActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    categoriaPOI: {},
    listaCategoriasPOI: [],
    loading: false,
    error: false,
    formSubmited: false
};

type CategoriasPOIAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { categoriaPOI?: {} | null, listaCategoriasPOI?: [] | null, loading?: boolean, +value ?: boolean };

const CategoriasPOI = (state: State = INIT_STATE, action: CategoriasPOIAction): any => {
    // console.log(action);
    switch (action.type) {
        case CategoriasPOIActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CategoriasPOIActionTypes.GET_CATEGORIA_POI: {
                    return {
                        ...state,
                        categoriaPOI: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasPOIActionTypes.LIST_CATEGORIAS_POI: {
                    return {
                        ...state,
                        listaCategoriasPOI: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasPOIActionTypes.ADD_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasPOIActionTypes.DELETE_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasPOIActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CategoriasPOIActionTypes.GET_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: action.payload.error,
                        categoriaPOI: {},
                        loading: false,
                    };
                }
                case CategoriasPOIActionTypes.LIST_CATEGORIAS_POI: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCategoriasPOI: [],
                        loading: false,
                    };
                }
                case CategoriasPOIActionTypes.ADD_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasPOIActionTypes.DELETE_CATEGORIA_POI: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasPOIActionTypes.GET_CATEGORIA_POI:
            return { ...state, error: false, loading: true };
        case CategoriasPOIActionTypes.LIST_CATEGORIAS_POI:
            return { ...state, error: false, loading: true };
        case CategoriasPOIActionTypes.ADD_CATEGORIA_POI:
            return { ...state, error: false, loading: true };
        case CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI:
            return { ...state, error: false, loading: true };
        case CategoriasPOIActionTypes.DELETE_CATEGORIA_POI:
            return { ...state, error: false, loading: true };
        case CategoriasPOIActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                categoriaPOI: {},
                listaCategoriasPOI: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default CategoriasPOI;
